


















































































import Vue from "vue";
import DateInput from "@/components/DateInput.vue";

import store, { MetRiportStore } from "../services/MetRiportStore";
import { MetRiportExportHeadDefaultProps } from "../models/MetRiportExportHead";

import { ValidationRules } from "@/models/Validation";
import { MetRiportExportHeadValidationRules as exportheadrules } from "../models/MetRiportExportHead";
import dayjs from "dayjs";
  
interface Data {
    store: MetRiportStore;
    exportHeadRules: ValidationRules;
}

export default Vue.extend<Data, {}, {}, {}>({
    components: {
        DateInput
    },

    async beforeMount() {        
        const metExportId: number = Number(this.$route.params["metExportId"]) || 0;     
        const metRiportId: number = Number(this.$route.params["metRiportId"]) || 0;     

        if (metExportId == 0) {
            await this.store.loadMetRiportHead(metRiportId);

            let prevMonthFirstDay = dayjs().subtract(1, 'month').startOf('month');
            let prevMonthLastDay = dayjs().subtract(1, 'month').endOf('month');
            if (prevMonthFirstDay.isBefore(this.store.metRiportHead.beginDate)) {
                prevMonthFirstDay = dayjs(this.store.metRiportHead.beginDate);
                prevMonthLastDay = dayjs(this.store.metRiportHead.endDate ?? new Date());
            }

            this.store.metRiportExportHead = {
                ...MetRiportExportHeadDefaultProps, 
                metisHead: this.store.metRiportHead.id,
                metisHeadName: this.store.metRiportHead.name,
                beginDate: prevMonthFirstDay.toDate(),
                endDate: prevMonthLastDay.toDate()
            };
        } 
        else {
            await this.store.loadMetRiportExportHead(metExportId);
        }
    },

    data() {
        return {
            store,
            exportHeadRules: exportheadrules
        };
    }
});
